export default {
  // Add to your translation files (create src/i18n/locales/ta/birth-chart.js)

  // Header Section
  "birth_chart_generator": "பிறப்பு ஜாதக உருவாக்கி",
  "create_your": "உங்கள்",
  "birth_chart": "பிறப்பு ஜாதகம்",
  "kundli_analysis": "& குண்டலி பகுப்பாய்வு",
  "birth_chart_description": "உங்கள் துல்லியமான பிறப்பு விவரங்களின் அடிப்படையில் கிரக நிலைகள், முன்கணிப்புகள், மற்றும் பரிகாரங்கள் உள்ளிட்ட விரிவான வேத ஜாதகத்தை உருவாக்குங்கள்.",

  // Form Fields
  "enter_birth_details": "பிறப்பு விவரங்களை உள்ளிடுங்கள்",
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_note": "துல்லியமான பிறந்த நேரம் சரியான முன்கணிப்புகளுக்கு மிக முக்கியம்",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "place_birth_note": "துல்லியமான கணக்கீடுகளுக்காக முழு பிறப்பு இடத்தை உள்ளிடுங்கள்",

  // Chart Options
  "chart_type": "ஜாதக வடிவம்",
  "south_indian_style": "தென் இந்திய முறை",
  "north_indian_style": "வட இந்திய முறை",
  "east_indian_style": "கிழக்கு இந்திய முறை",

  // Actions
  "generate_birth_chart": "ஜாதகம் உருவாக்கவும்",
  "generating_chart": "ஜாதகம் உருவாக்கப்படுகிறது",
  "download_chart": "ஜாதகத்தை பதிவிறக்குங்கள்",
  "view_detailed_report": "விரிவான அறிக்கையைப் பார்க்கவும்",

  // Features
  "what_you_get": "நீங்கள் பெறுவது",
  "detailed_planetary_positions": "விரிவான கிரக நிலைகள்",
  "zodiac_sign_analysis": "ராசி அடையாளம் பகுப்பாய்வு",
  "dasha_system_predictions": "தசா முறையின் முன்கணிப்புகள்",
  "remedial_suggestions": "பரிகார ஆலோசனைகள்",

  // Visual Elements
  "sample_birth_chart": "மாதிரி பிறப்பு ஜாதகம்",
  "sample_chart_description": "உங்கள் தனிப்பட்ட ஜாதகம் இவ்வாறு தோன்றும்",
  "astrological_elements": "ஜோதிட கூறுகள்",

  // Planets
  "sun": "சூரியன்",
  "moon": "சந்திரன்",
  "mars": "செவ்வாய்",
  "mercury": "புதன்",
  "jupiter": "வியாழன்",
  "venus": "சுக்கிரன்",

  // Results
  "your_birth_chart": "உங்கள் பிறப்பு ஜாதகம்",
  "chart_generated_successfully": "ஜாதகம் வெற்றிகரமாக உருவாக்கப்பட்டது!",
  "chart_ready_message": "விரிவான பகுப்பாய்வு மற்றும் முன்கணிப்புகளுடன் உங்கள் தனிப்பட்ட ஜாதகம் தயாராக உள்ளது."
}
